<div class="hb-fieldset">
  <div class="hb-legend">
    <div class="hb-legend-tekst" id="velg-visning" aria-hidden="true">Velg visning:</div>
    <hb-hjelpetekst labelledby="velg-visning">
      <p class="hb-avstand--ingen"><strong>Fylke eller kommune:</strong></p>
      <p class="hb-avstand--avsnitt">Du velger om du vil se tallene fremstilt per fylke eller kommune i visualiseringen.</p>
    </hb-hjelpetekst>
  </div>
  <fieldset class="hb-felt">
    <legend class="hb-screenreader-only">Velg visning:</legend>
    <ul class="hb-feltliste hb-feltliste--horisontal">
      <li>
        <input
          (click)="selectedFylkeKommune($event)"
          [id]="'fylkeRadio'"
          class="hb-radiobutton"
          type="radio"
          name="fylkeKommune"
          [value]="'fylke'"
          [checked]="kommuneFylkeValgt === 'fylke'"
        />
        <div class="hb-label">
          <label class="hb-label-tekst" [for]="'fylkeRadio'">
            <span>Fylke</span>
          </label>
        </div>
      </li>
      <li>
        <input
          (click)="selectedFylkeKommune($event)"
          [id]="'kommuneRadio'"
          class="hb-radiobutton"
          type="radio"
          name="fylkeKommune"
          [value]="'kommune'"
          [checked]="kommuneFylkeValgt === 'kommune'"
        />
        <div class="hb-label">
          <label class="hb-label-tekst" [for]="'kommuneRadio'">
            <span>Kommune</span>
          </label>
        </div>
      </li>
    </ul>
  </fieldset>
</div>
